import { TFunction } from 'i18next';
import * as yup from 'yup';
import { maxText, nameText } from './rules';

const decimalsOf = (value: number) => {
  const text = String(value);
  return text.includes('.') ? text.split('.')[1].length : 0;
};

const line = (t: TFunction) =>
  yup.object({
    quantity: yup
      .number()
      .nullable()
      .test('quantity', function (value) {
        if (value === null || value === undefined) return true;
        if (value < 0) return this.createError({ message: t('validation.min', { min: 0 }) });
        return decimalsOf(value) <= 3 || this.createError({ message: t('validation.decimals', { count: 3 }) });
      }),
    unitPriceNetOverride: yup
      .number()
      .nullable()
      .test('price', function (value) {
        if (value === null || value === undefined) return true;
        if (value < 0) return this.createError({ message: t('validation.min', { min: 0 }) });
        return decimalsOf(value) <= 2 || this.createError({ message: t('validation.decimals', { count: 2 }) });
      })
  });

/** Bounds from UpsertBillingSchemeDto; the lines are the editor's, so they are numbers already. */
export const billingSchemeSchema = (t: TFunction) =>
  yup.object({
    name: nameText(t, 2, 120, t('validation.scheme.nameEmpty')),
    description: maxText(t, 500),
    items: yup.array().of(line(t)).min(1, t('validation.scheme.itemsEmpty')).default([])
  });
